import { URL } from '../../config'
import { getRequest } from '../functions/httpRequest'

export const userrole = function (token) 
{
  const roleURL =  `${URL.user}/userrole` 
  return getRequest(roleURL,'json',token)
}



// WEBPACK FOOTER //
// ./src/utils/api/userrole.js